function LoadingScreen(): JSX.Element {
  return (
    <p>Loading ...</p>
  );
}

export default LoadingScreen;
